import { render, staticRenderFns } from "./SubmitDialog.vue?vue&type=template&id=bb17e5cc&scoped=true&"
import script from "./SubmitDialog.vue?vue&type=script&lang=js&"
export * from "./SubmitDialog.vue?vue&type=script&lang=js&"
import style0 from "./SubmitDialog.vue?vue&type=style&index=0&id=bb17e5cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb17e5cc",
  null
  
)

export default component.exports